import { MuiProvider } from "./mui.provider";
import QueryProvider from "./query.provider";
import { Toaster } from "react-hot-toast";
import Web3Provider from "./web3.provider";
import { AuthProvider } from "./auth.provider";

const AppProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <MuiProvider>
      <QueryProvider>
        <Web3Provider>
          <AuthProvider>
            <Toaster position="top-center" />
            {children}
          </AuthProvider>
        </Web3Provider>
      </QueryProvider>
    </MuiProvider>
  );
};

export default AppProvider;
